import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

export default function SEO({ title, pageSeo, schemaData }) {
  const { siteSettingsData } = useStaticQuery(graphql`
    query {
      siteSettingsData: allSanitySiteSettings {
        nodes {
          siteName
          twitterHandletag
        }
      }
    }
  `);

  const siteSettings = siteSettingsData.nodes[0];
  const GetCurrentPageURL = () =>
    typeof window !== 'undefined' ? window.location.href : '';

  if (GetCurrentPageURL().includes('/fivem/')) {
    return (
      <Helmet htmlAttributes={{ lang: 'en-gb' }}>
        <meta name="robots" content="noindex" />
        <title>{`${title} | ${siteSettings.siteName}`}</title>
        <link rel="stylesheet" href="https://use.typekit.net/ptq5ghf.css"></link>
      </Helmet>
    );
  }

  return (
    <Helmet htmlAttributes={{ lang: 'en-gb' }}>
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <title>{`${title} | ${siteSettings.siteName}`}</title>
      <link rel="icon" href="/favicon.ico" />
      <meta property="og:type" content="website" />

      {
        // Meta No Index
        pageSeo && pageSeo.metaTags && pageSeo.metaTags !== 'default' ? (
          <meta name="robots" content={pageSeo.metaTags} />
        ) : (
          ''
        )
      }

      {
        // Canonical Link
        pageSeo && pageSeo.canonicalLink ? (
          <link rel="canonical" href={pageSeo.canonicalLink} />
        ) : (
          ''
        )
      }
      {
        // Open Graph Description
        pageSeo && pageSeo.seoDescription ? (
          <meta name="description" content={pageSeo.seoDescription} />
        ) : (
          ''
        )
      }
      {
        // OpenGraph Site Name
        siteSettings.siteName ? (
          <meta property="og:site_name" content={siteSettings.siteName} />
        ) : (
          ''
        )
      }
      {
        // Open Graph Title
        (pageSeo && pageSeo.seoTitle) || title ? (
          <meta
            property="og:title"
            content={
              pageSeo && pageSeo.seoTitle
                ? `${pageSeo.seoTitle} | ${siteSettings.siteName}`
                : `${title} | ${siteSettings.siteName}`
            }
          />
        ) : (
          ''
        )
      }
      {
        // OpenGraph Current URL
        GetCurrentPageURL() !== '' ? (
          <meta property="og:url" content={GetCurrentPageURL()} />
        ) : (
          ''
        )
      }
      {
        // Open Graph Description
        pageSeo && pageSeo.seoDescription ? (
          <meta property="og:description" content={pageSeo.seoDescription} />
        ) : (
          ''
        )
      }
      {
        // Open Graph Image
        pageSeo && pageSeo.seoMetaImage && pageSeo.seoMetaImage.asset.url ? (
          <meta property="og:image" content={pageSeo.seoMetaImage.asset.url} />
        ) : (
          ''
        )
      }
      {
        // Twitter Handle Tag
        siteSettings.twitterHandletag ? (
          <meta property="twitter:site" content={siteSettings.twitterHandletag} />
        ) : (
          ''
        )
      }
      {
        // Twitter Title
        (pageSeo && pageSeo.seoTitle) || title ? (
          <meta
          property="twitter:title"
            content={
              pageSeo && pageSeo.seoTitle
                ? `${pageSeo.seoTitle} | ${siteSettings.siteName}`
                : `${title} | ${siteSettings.siteName}`
            }
          />
        ) : (
          ''
        )
      }
      {
        // Twitter Description
        pageSeo && pageSeo.seoDescription ? (
          <meta property="twitter:description" content={pageSeo.seoDescription} />
        ) : (
          ''
        )
      }
      {
        // Twitter Image
        pageSeo && pageSeo.seoMetaImage && pageSeo.seoMetaImage.asset.url ? (
          <meta property="twitter:image" content={pageSeo.seoMetaImage.asset.url} />
        ) : (
          ''
        )
      }

      {schemaData && <script type="application/ld+json">{JSON.stringify(schemaData)}</script>}
    </Helmet>
  );
}
